import React from "react";
import NavBar from "./NavBar";

import SideBar from "./SideBar";

import { Toolbar } from "@material-ui/core";
import { useStyles } from "../styles/mainStyles";
import { connect } from "react-redux";

import { useWindowDimensions } from "./MediaQuery";
import useOrders from "../redux/Orders/useOrders";

function Layout({ children }) {
  const classes = useStyles();
  const [sideBarStatus, setSideBarStatus] = React.useState(false);

  let layoutRef = React.useRef();
  const { width } = useWindowDimensions();

  useOrders();
  return (
    <>
      <div className={classes.LayoutRoot} ref={layoutRef}>
        <NavBar
          setOpen={setSideBarStatus}
          width={width}
          layoutRef={layoutRef}
        />
        <SideBar
          width={width}
          sideStatus={sideBarStatus}
          setSideStatus={setSideBarStatus}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            paddingLeft: 4,
            marginTop: 10,
          }}
        >
          <Toolbar />

          {children}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (props) => {
  const {
    // OrderReducer,
    // searchReducer,
    loginReducer,
    generalReducer,
  } = props;

  // const { activeOrders, readyToSendOrders } = OrderReducer;
  const { 
    // popupMessages,
     refresh, letRefresh } = generalReducer;
  const { officeAuth, pwa_install } = loginReducer;

  return {
    // searchReducer,
    // popupMessages,
    refresh,
    letRefresh,

    officeAuth,

    pwa_install,
  };
};

export default connect(mapStateToProps)(Layout);
